import { render, staticRenderFns } from "./ParametersManagement.vue?vue&type=template&id=2f015b8c&scoped=true&"
import script from "./ParametersManagement.vue?vue&type=script&lang=js&"
export * from "./ParametersManagement.vue?vue&type=script&lang=js&"
import style0 from "./ParametersManagement.vue?vue&type=style&index=0&id=2f015b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f015b8c",
  null
  
)

export default component.exports